import { MessageV2DTO } from 'support/types';

import { DocumentDisplayConfig } from './DocumentDisplayConfigContext';

export const deriveDocumentDisplayConfig = (message: MessageV2DTO | undefined): DocumentDisplayConfig => {
  const documentUnderstanding = message?.metadata?.document_understanding;

  if (!documentUnderstanding) {
    return { showPriceFields: true };
  }

  const strategy = documentUnderstanding.prices_extraction_strategy;
  return {
    showPriceFields: !!strategy && strategy !== 'disabled',
  };
};
